<div [hidden] = "!active" role="tabpanel" [attr.aria-labelledby]= "title">
  <ng-content></ng-content>
</div>
